<script setup lang="ts">
import Button from '@/components/common/Button.vue'

const bgImage =
  'https://res.cloudinary.com/benchmarkminerals/image/upload/c_scale,f_auto,w_1800,q_auto/v1733251359/assets/all-prices-subscription/price_toolkit_mimsfk.png'
</script>

<template>
  <div class="relative py-[42px] px-6 flex flex-col items-center text-white">
    <img
      class="absolute w-full h-full -z-10 object-cover top-0 rounded-xl"
      :src="bgImage"
      alt="toolkit section background"
    />
    <h2 class="text-h2 font-bold">Your Price Access Toolkit</h2>
    <p class="text-lg mt-3 max-w-[708px] text-center">
      Our access and integration tools enable optimised utilisation of
      Benchmark’s price data, best suited to your business.
    </p>
    <div class="flex gap-x-6 mt-6">
      <Button
        class="!bg-[#23252cc0] transition-all duration-500 !text-white backdrop-blur-sm hover:!bg-s-600 hover:!outline-p-700"
        variant="clean"
        link="/price-dashboard"
      >
        Price Dashboard
      </Button>
      <Button
        class="!bg-[#23252cc0] transition-all duration-500 !text-white backdrop-blur-sm hover:!bg-s-600 hover:!outline-p-700"
        variant="clean"
        link="/excel-add-in"
      >
        Excel Add-In
      </Button>
      <Button
        class="!bg-[#23252cc0] transition-all duration-500 !text-white backdrop-blur-sm hover:!bg-s-600 hover:!outline-p-700"
        variant="clean"
        link="/api"
      >
        Benchmark API
      </Button>
      <Button
        class="!bg-[#23252cc0] transition-all duration-500 !text-white backdrop-blur-sm hover:!bg-s-600 hover:!outline-p-700"
        variant="clean"
        link="/app"
      >
        Benchmark App
      </Button>
    </div>
  </div>
</template>
